import { IntegrationName } from 'signup-ui-lego-core/constants/IntegrationName';
import { getIntegrationKey } from '../routing/getIntegrationKey';
export const getIntegrationName = () => {
  const integrationKey = getIntegrationKey();
  let fallback = null;

  if (document.referrer) {
    // For unknown integrations we use the document.referrer as the integration name.
    fallback = new URL(document.referrer).hostname;
  }

  if (!integrationKey) {
    return fallback;
  }

  return IntegrationName[integrationKey] || fallback;
};